<template>
  <div class="form-field" :class="{ required: required }">
    <h4 v-if="labelTranslate" class="form-field-header" v-translate>{{ label }}</h4>
    <h4 v-else class="form-field-header">{{ label }}</h4>
    <div class="form-field-container">
      <!-- ID specified -->
      <input
        v-if="id !== ''"
        :id="id"
        class="form-field-text"
        :type="type"
        :tabindex="tabIndex"
        :value="$attrs.value"
        :data-action="actionName"
        v-mask="mask"
        :placeholder="placeholder"
        @input="$emit('update:value', $event.target.value)"
      />

      <!-- No ID -->
      <input
        v-else
        class="form-field-text"
        :type="type"
        :tabindex="tabIndex"
        :value="$attrs.value"
        :placeholder="placeholder"
        :data-action="actionName"
        :v-mask="mask"
        @input="$emit('update:value', $event.target.value)"
      />
    </div>
    <div v-if="helpText" class="help-text">
      <span v-if="helpTextTranslate" v-translate>{{ helpText }}</span>
      <span v-else>{{ helpText }}</span>
    </div>
    <div v-if="showErrorMessage && errorMessage" class="error-text">
      <span v-html="errorMessage" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormTextField',
  props: {
    id: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      deault: 'text',
    },
    label: {
      type: String,
      required: true,
    },
    tabIndex: {
      type: Number,
    },
    helpText: {
      type: String,
      default: null,
    },
    helpTextTranslate: {
      type: Boolean,
      default: true,
    },
    showErrorMessage: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    labelTranslate: {
      type: Boolean,
      default: true,
    },
    mask: {
      type: String,
      default: '',
    },
    actionName: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['update:value'],
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/responsive';

.form-field-container {
  display: flex;
}

.form-field-text {
  background: #f4f4f5;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #9e9e9e;
  flex: 1;
  padding: 1rem;
}
</style>
